import{COLORS as o}from"./Theme.js";const r=o.background.brand;export{r as PRIMARY};
